import React, { useContext } from "react";
import { StaffContext } from "../../../Context";
import "./PremiumStaffSelect.css";

const Avatar = ({ name, colorIndex }) => {
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const colors = [
    "#115e59", // Teal 800
    "#0f766e", // Teal 700
    "#0d9488", // Teal 600
    "#1e293b", // Slate 800
    "#334155", // Slate 700
    "#475569", // Slate 600
  ];

  const bgColor = colors[colorIndex % colors.length];

  return (
    <div className="staff-avatar" style={{ backgroundColor: bgColor, width: '32px', height: '32px', fontSize: '0.8rem' }}>
      {initials}
    </div>
  );
};

export default function PremiumStaffBadge({ id, size = "medium" }) {
  const { findStaff, staff } = useContext(StaffContext);
  if (!id) return <div className="staff-info">No staff</div>;
  
  const member = findStaff(id);
  if (!member) return <div className="staff-info">No staff</div>;

  const colorIndex = staff.indexOf(member);

  return (
    <div className="selected-item" style={{ gap: '0.5rem' }}>
      <Avatar name={member.name} colorIndex={colorIndex} />
      <div className="selected-text">
        <div className="staff-name" style={{ fontSize: size === 'small' ? '0.85rem' : '0.95rem' }}>
          {member.name}
        </div>
        {member.email && (
          <div className="staff-role-meta" style={{ fontSize: '0.75rem' }}>
            {member.email}
          </div>
        )}
      </div>
    </div>
  );
}
